import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitApplicationApprove } from '../service'

export const useSubmitApplicationApprove: WriteHook<{ id: number }, void> = (opts) =>
  useMutationManager(submitApplicationApprove, opts)
